const IGNORADAS = new Set([
  'de', 'da', 'do', 'das', 'dos', 'para', 'por', 'com', 'sem', 'em', 'no', 'na', 'nos', 'nas', 'ao', 'aos', 'e', 'o', 'a', 'os', 'as',
  'um', 'uma', 'ref', 'referente', 'pgto', 'pagto', 'pagamento', 'pag', 'ted', 'doc', 'pix', 'tef', 'cred', 'deb', 'credito', 'debito',
  'transf', 'transferencia', 'envio', 'conta', 'valor', 'proj', 'projeto', 'item',
]);

const normalizar = texto => (texto || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()
  .replace(/[^a-z0-9]+/g, ' ').trim();

const palavras = texto => normalizar(texto).split(' ')
  .filter(p => p && !IGNORADAS.has(p) && (p.length >= 3 || /^\d{2,}$/.test(p)));

function pontoDoTermo(termo, tokensItem) {
  let melhor = 0;
  let casou = '';
  for (const token of tokensItem) {
    let ponto = 0;
    if (token === termo) ponto = 3;
    else if (/^\d+$/.test(termo)) ponto = 0;
    else if (token.startsWith(termo)) ponto = termo.length >= 4 ? 2.5 : 2;
    else if (termo.length >= 5 && termo.startsWith(token) && token.length >= 4) ponto = 1.5;
    if (ponto > melhor) { melhor = ponto; casou = token; }
  }
  return { ponto: melhor, casou };
}

export default function sugerirItem(itens, texto, disponivel = () => true) {
  const termos = [...new Set(palavras(texto))];
  const candidatos = (itens || []).filter(disponivel);
  if (termos.length === 0 || candidatos.length === 0) return [];

  const tokensPorItem = candidatos.map(i => [...new Set(palavras(i.nome))]);
  const frequencia = {};
  tokensPorItem.forEach(tokens => tokens.forEach(t => { frequencia[t] = (frequencia[t] || 0) + 1; }));
  const comum = t => candidatos.length >= 3 && frequencia[t] / candidatos.length > 0.5;

  const ranking = candidatos.map((item, i) => {
    const tokens = tokensPorItem[i].filter(t => !comum(t));
    let total = 0;
    const motivos = [];
    termos.forEach(termo => {
      const { ponto, casou } = pontoDoTermo(termo, tokens);
      if (ponto > 0) { total += ponto; motivos.push(termo === casou ? termo : termo + ' → ' + casou); }
    });
    return { item, total, motivos };
  }).sort((a, b) => b.total - a.total);

  const melhor = ranking.length ? ranking[0].total : 0;
  if (melhor < 2) return [];

  return ranking.filter(r => r.total >= 2 && melhor - r.total < 1).slice(0, 3)
    .map(r => ({ id: r.item.id, motivos: r.motivos }));
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/conciliacao-projeto/sugestao-item.js